<template>
  <v-navigation-drawer :width="290" v-model="drawer" clipped app>
    <v-treeview
      shaped
      hoverable
      v-model="tree"
      :items="mapItems"
      activatable
      item-key="name"
      open-on-click
      color="warning"
      return-object
      @update:active="listItemClick"
    >
      <template slot="name" slot-scope="{ item }">
        <div @click="listItemClick(item)">{{ item.name }}</div>
      </template>
      <template v-slot:prepend="{ item, open }">
        <v-icon v-if="!item.icon">
          {{ open ? "label" : "trending_flat" }}
        </v-icon>
        <v-icon v-else>
          {{ item.icon }}
        </v-icon>
      </template>
    </v-treeview>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "home",
  props: {
    source: String,
    drawer: Boolean,
  },
  data() {
    return {
      drawer: null,
      activeRoute: null,
      active: [],
      tree: [],
    };
  },
  watch: {
    drawer() {
      this.$emit("update:drawer", this.drawer);
    },
    deep: true,
    language: function () {
      console.log("lang changed");
      this.getNavMenu();

    },
    selection(newValue) {
      this.onUpdate(newValue);
    },
  },
  computed: {
    ...mapGetters({ items: "category_tree/items" }),
    ...mapGetters({ language: "app/language" }),

    mapItems() {
      let navbar = [
        {
          name: this.$t("_menu.dashboard"),
          icon: "dashboard",
          route: "/dashboard",
          role: "ROLE_PARKING_LIST",
        },
        {
          name: this.$t("_menu.category"),
          icon: "collections_bookmark",
          route: "/category-groups",
          role: "ROLE_PARKING_LIST",
        },
        {
          name: this.$t("_menu.mayor"),
          icon: "account_circle",
          route: "/mayor",
          role: "ROLE_PARKING_LIST",
        },
        {
          name: this.$t("_menu.incidents"),
          icon: "receipt",
          route: "/incidents",
          role: "ROLE_PARKING_LIST",
        },
        {
          name: this.$t("_menu.notifications"),
          icon: "notifications",
          route: "/notifications",
          role: "ROLE_PARKING_LIST",
        },
        {
          name: this.$t("_menu.issues"),
          icon: "mark_unread_chat_alt",
          route: "/issues",
          role: "ROLE_PARKING_LIST",
        },
        {
          name: this.$t("_menu.news"),
          icon: "campaign",
          route: "/news",
          role: "ROLE_PARKING_LIST",
        },
      ];
      let mapped = this.items;
      let navDrawer = [...navbar, ...mapped]
      let afterNavBar = [
        {
          name: this.$t("_menu.settings"),
          icon: "settings",
          route: "/settings",
          role: "ROLE_PARKING_LIST",
        },]
      return [...navDrawer, ...afterNavBar];
    },
  },
  mounted() {
    console.log("navigation are refreshing due to mounting");
    this.getNavMenu();
  },
  created() {
    console.log("navigation are refreshing due to created");
    this.getNavMenu();
  },
  methods: {
    ...mapActions(["category_tree/getItems"]),

    onClick(item) {
      console.log("click", item);
    },
    async getNavMenu() {
      await this.$store.dispatch("category_tree/getItems");
    },

    prependIcon(item) {
      if (item.icon) {
        return item.icon;
      }
    },
    appendIcon(item) {
      if (item.children && item.children.length) {
        return "expand_more";
      }
      return null;
    },
    listItemClick(item) {
      console.log("click menu itemmmm", item);
      if (item[0].hasOwnProperty("parentCategoryId")) {
        this.$router.push({
          name: "placespage",
          params: { id: item[0].id, place: item[0].name, icon: item[0].icon },
        });
      } else {
        this.$router.push(item[0].route);
      }
    },
  },
};
</script>

<style lang="scss">
.v-navigation-drawer {
  .v-list {
    &-group--active {
      .v-list-group__items {
        background: #a0adb6;
      }
      .v-list-group__header {
        background: #a0adb6;
      }
    }
    .theme--dark {
      .v-icon {
        color: primary !important;
      }
    }
  }
}
.active-item {
  position: relative;
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.3 !important;
    background-color: #fafafa !important;
  }
}
</style>